import React, {
  useRef,
  useState,
  // useEffect
} from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
// import TablaDetallesAprobacionOrden from './tablaAgregarAprobaciones';
import useTableFijo from "../useTableFijo";
import CatalogoSolicitudTraslado from "../../catalogos/catalogoSolicitudTrasFT";
import { AgregarCompromiso } from "../presupuesto/modalAgregarCompromiso";

import { DangerButton, InfoButton, PrimaryButton, SuccessButton } from "../../ui/buttons/Button";
import { Textarea, Input } from "../../ui/inputs/Input";

export const ModalEnviarSolicitudTrasladoFondos = (props) => {
  let prue;

  if (props.devolver === '1') {
    prue = [
      {
        id: "1",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "N° Documento",
        textAlign: "center",
      },
      {
        id: "2",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Concepto",
        textAlign: "center",
      },
      {
        id: "3",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Opcion",
        textAlign: "center",
      },
    ]
  } else {
    prue = [
      {
        id: "1",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "N° Documento",
        textAlign: "center",
      },
      {
        id: "2",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Concepto",
        textAlign: "center",
      },
      {
        id: "4",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Motivo",
        textAlign: "center",
      },
      {
        id: "3",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Opcion",
        textAlign: "center",
      },
    ]
  }

  const headCells = prue;

  /* const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° Documento",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Concepto",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Opcion",
      textAlign: "center",
    },
  ]; */

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  // const espiritu = JSON.parse(localStorage.getItem('espiritu'));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState("hidden");
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("hola papa");
  const [mostrar5, setMostrar5] = useState(false);

  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [codigo, setCodigo] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtFecha = useRef();
  // const txtFechaAprobacion = useRef();
  const txtObservacion = useRef();
  // const txtNp = useRef();
  const txtCodigo = useRef();

  const {
    TblContainer,
    TblHead,
    // TblPagination,
    recordsAfterPagingAndSorting,
  } = useTableFijo(records, headCells, filterFn, 220);

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar las Solicitudes",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      // let datos = [];
      let datost = [];
      // let validad = [];
      for (let e = 0; e < records.length; e++) {
        datost.push({
          nid: records[e].idaprobacionesdetalle,
          motiv: records[e].motivo,
          idorden: records[e].idordenpago,
          conce: records[e].concepto,
          idapro: 0,
          tip: parseInt(records[e].tipo),
        });
      }

      setBody({
        operacion: operacion,
        nid: txtCodigo.current.value !== "" ? txtCodigo.current.value : 0,
        fec: txtFecha.current.value,
        obser: txtObservacion.current.value,
        tip: props.tipocom,
        depart: 5,
        idefi: idefiscal,
        devol: props.devolver,
        aprob: true,
        ordenes: records,
        //tipo: props.tipo,
      });
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de " + (parseInt(props.devolver) === 1 ? "Aprobar" : "Desaprobar")  + " estos Documentos?.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const ActualizarDetalle = (id) => {
    let endpoint = `${op.conexion}/api/administracion/detalleaprobacionactu2`;
    setActivate(true);
    let body = {
      idapro: id,
      tipocom: 4,

      ordenes: records,
      idefi: idefiscal,
      tipo: props.tip,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "En el Documento Nº " + idAprob + " fué  " + props.tipo === 1 ? "Enviada " : "Devuelta " + "Solicitud de Traslado de Fondos",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/aprobacionesactfondo`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          //ActualizarDetalle(response.data[0].aprobaciones_actfondoter);
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "En el Documento Nº " + response.data.valret + " fué  " + props.tipo === 1 ? "Enviada " : "Devuelta " + "Solicitud de Traslado de Fondos",
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();
    setValues(item);
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setRecords([]);
    setVisible("hidden");
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setTitulo("");
    setActivo(true);
  };

  const opciones = (ope, item) => (event) => {
    event.preventDefault();
    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
    } else {
      /* const record = records.filter(
        (record) => record.idaprobacion !== values.idaprobacion
      ); */
      const record = records.filter(
        (record) => record.idaprobacion !== item.idaprobacion
      );
      setRecords(record);
    }
  };
  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
  };

  // const BaseDatos = (data) => {
  //     if (data.length > 0) {
  //         setActivo(false);
  //         setValida(1);
  //     } else {
  //         setActivo(true);
  //         setValida(0);
  //     }
  //     setData(data);
  //     console.log(data);
  // }

  const agregarOrdenPago = (values) => {
    setMostrar5(false);
    if (
      records.some(
        (record) =>
          record.idaprobacion.toString() === values.idaprobacion.toString()
      )
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Ya esta orden de pago fue agregada.",
        icono: "informacion",
      });
    } else {
      setRecords([...records, values]);
    }
  };

  const handleAceptarDatos = (datos) => {
    setMostrar5(false);

    console.log(datos);

    let data = [...records];


    for (let i = 0; i < datos.length; i++) {

      data.push({
        idaprobacion: datos[i].idordencompra,
        descripaprobacion: datos[i].concepto,
        motivo: datos[i].motivodevol,
        idaprobacionesdetalle: 0,
        tipo: datos[i].tipo,
        val: datos[i].val,
        validaparam: datos[i].validaparam
      });

    }

    setRecords(data);
    //props.data(data);
  }

  const cerrarModalActualizar = () => {

    setMostrar5(false);
  }

  // Función para manejar la impresión
  const handleImprimir = () => {

    // Determinar el tipo de reporte según los parámetros
    let fileName = '';
    let nombreid = '';
    let nombreid1 = 'true';
    let monto = '';
    let condicion = '';
    let condicion2 = '';
    let titulo = '';
    let direccion = '';
    let direcciondev = '';
    let enca = props.tipo === 1 ? 'ENVIO' : 'DEVOLUCION';
    let estat = props.tipo === 1 ? 'envian para su debido proceso' : 'devuelven para su debida revisión';
    let proveedor = '';
    let selectDistinct = props.tipocom === 3 ? ' select distinct ' : '';

    // Obtener el ID de la aprobación (del registro actual o de props)
    const idAprobacion = props.aprobaciones?.idaprobaciones || txtCodigo.current?.value || codigo;

    // Configurar según tipocom (basado en el código Java)
    switch (parseInt(props.tipocom)) {
      case 0: // Compromisos
        fileName = 'compromiso';
        nombreid = 'idcompromiso';
        monto = 'montocompromiso';
        condicion = '';
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = compromiso.idproveedor';
        titulo = 'COMPROMISOS';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 1: // Ordenes de Pago
        fileName = 'ordenpago';
        // Según el espíritu, puede ser numordenpago o idordenpago
        if ([0, 1, 9, 12, 13, 14, 15].includes(parseInt(espiritu))) {
          nombreid = 'ordenpago.numordenpago';
        } else {
          nombreid = 'ordenpago.idordenpago';
        }
        nombreid1 = 'ordenpago.idordenpago';
        monto = 'montoordenpago';
        condicion = `LEFT JOIN compromiso ON compromiso.idcompromiso = ordenpago.idcompromiso and compromiso.idefiscal = ${idefiscal}`;
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = compromiso.idproveedor or proveedor.idproveedor = ordenpago.idproveedororden';
        titulo = 'ORDENES DE PAGO';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 2: // Solicitudes de Compras/Servicios
        fileName = 'ordencompra';
        if ([8, 9, 14, 15].includes(parseInt(espiritu))) {
          nombreid = '(CASE WHEN aprobacionesdetalle.tipo = 0 then idordencompra else idordenservicio end)';
        } else {
          nombreid = 'idordencompra';
        }
        monto = 'monto + montoiva';
        condicion = '';
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = ordencompra.idproveedor';
        titulo = 'SOLICITUDES DE COMPRAS/SERVICIOS';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 3: // Solicitudes de Pago de Obras
        fileName = 'solicitudpagoobras';
        nombreid = 'idsolicitudpagoobras';
        monto = 'monto';
        condicion = 'LEFT JOIN obraasignada ON obraasignada.idobraasignada = solicitudpagoobras.idobraasignada';
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = obraasignada.idproveedor';
        titulo = 'SOLICITUDES DE PAGO DE OBRAS y SERVICIOS';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 4: // Solicitud de Traslado de Fondos
        fileName = 'retenciondetalle';
        nombreid = 'idaprobacion';
        monto = 'montototalaprob';
        condicion = `LEFT JOIN retenciondetalle ON retenciondetalle.idaprobacion = aprobacionesdetalle.idordenpago and retenciondetalle.idefiscal <= ${idefiscal}`;
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = 20';
        titulo = 'SOLICITUD DE TRASLADO DE FONDOS';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 5: // Presupuesto Base
        fileName = 'presupuestobase';
        nombreid = 'idpresupuestobase';
        monto = 'monto + montoiva';
        condicion = '';
        condicion2 = '';
        titulo = 'PRESUPUESTO BASE';
        proveedor = 'null AS razonsocial';
        break;

      case 6: // Precompromisos
        fileName = 'precompromiso';
        nombreid = 'idprecompromiso';
        monto = 'montocompromiso';
        condicion = '';
        condicion2 = '';
        titulo = 'PRECOMPROMISOS';
        proveedor = "'' AS razonsocial";
        break;

      case 7: // Solicitudes de Donaciones
        fileName = 'ordencompra';
        nombreid = 'idordendonacion';
        monto = 'monto + montoiva';
        condicion = '';
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = ordencompra.idproveedor';
        titulo = 'SOLICITUDES DE DONACIONES';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      default:
        fileName = 'compromiso';
        nombreid = 'idcompromiso';
        monto = 'montocompromiso';
        titulo = 'DOCUMENTOS';
        proveedor = 'null AS razonsocial';
    }

    // Configurar direcciones según ubicación (basado en el código Java)
    if (props.ubica === 42) {
      if (props.tipocom === 0) {
        direccion = 'Administración';
        direcciondev = props.tipo === 0 ? 'Director de Administracion' : 'Unidad de Tesoreria';
      } else {
        direccion = 'Administración';
        direcciondev = props.tipo === 0 ? 'Director de Administracion' : 'Unidad de Tesoreria';
      }
    } else if (props.ubica === 48) {
      direccion = 'Tesorería';
      direcciondev = 'Unidad de Control Posterior';
    } else if (props.ubica === 41) {
      if (props.tipo === 0) {
        direccion = 'Control Posterior';
        direcciondev = 'Unidad de Tesoreria';
      } else {
        direccion = 'Control Posterior';
        direcciondev = 'Unidad de Contabilidad';
      }
    } else if (props.ubica === 44) {
      direccion = 'Unidad de Tesoreria';
      direcciondev = 'Unidad de Administración';
    } else if (props.ubica === 40) {
      if (props.tipocom === 2) {
        direccion = 'Presupuesto';
        direcciondev = props.tipo === 0 ? 'Unidad de Compras' : 'Unidad de Administración';
      } else if (props.tipocom === 3) {
        direccion = 'Unidad de Administración';
        direcciondev = props.tipo === 0 ? 'Dirección de Ingeniería Municipal' : 'Unidad de Administración';
      } else if (props.tipocom === 0) {
        direccion = 'Presupuesto';
        direcciondev = props.tipo === 0 ? 'Dirección de Ingeniería Municipal' : 'Unidad de Administración';
      }
    } else if (props.ubica === 38) {
      if (props.tipo === 1) {
        direccion = parseInt(espiritu) === 8 ? 'Dirección de Administración' : 'Dirección de Compras';
        direcciondev = 'Dirección de Presupuesto';
      } else {
        direccion = parseInt(espiritu) === 8 ? 'Dirección de Administración' : 'División de Compras';
        direcciondev = 'Dirección de Presupuesto';
      }
    } else if (props.ubica === 95) {
      if (props.tipo === 1) {
        direccion = 'Despacho del Alcalde';
        direcciondev = 'Dirección de Presupuesto';
      } else {
        direccion = 'Dirección de Presupuesto';
        direcciondev = 'Despacho del Alcalde';
      }
    } else if (props.ubica === 58) {
      direccion = 'División de Compras';
      direcciondev = 'Dirección de Administración';
    } else if (props.ubica === 59) {
      direccion = 'Dirección de Presupuesto';
      direcciondev = 'Dirección de Administración';
    } else if (props.ubica === 1 && props.tipocom === 4) {
      if (props.tipo === 0) {
        direccion = 'Unidad de Administración';
        direcciondev = 'Unidad de Retención';
      } else {
        direccion = 'Unidad de Retención';
        direcciondev = 'Unidad de Administración';
      }
    } else if (props.ubica === 80) {
      direccion = 'Dirección de Compras';
      direcciondev = 'Dirección de Presupuesto';
    } else if (props.ubica === 90) {
      direccion = 'Presupuesto';
      direcciondev = 'Dirección de Compras';
    } else if (props.ubica === 39) {
      direccion = 'Ingeniería';
      direcciondev = props.tipo === 0 ? 'Dirección de Ingeniería Municipal' : 'Unidad de Administración';
    } else if (props.ubica === 43) {
      direccion = 'Contabilidad';
      direcciondev = 'Unidad de Contabilidad';
    }

    // Determinar el nombre del reporte según el tipo
    let reporteName = 'ControlDocumentos';
    if (props.tipocom === 4) {
      reporteName = 'ControlDocumentosAprob';
    } else if (props.tipocom === 1 && [0, 1, 9, 12, 13, 14, 15].includes(parseInt(espiritu))) {
      reporteName = 'ControlDocumentosOrdenPago';
    }

    // Construir la URL para el reporte con TODOS los parámetros necesarios
    const reporteUrl = `${op.reportes}/administracionTesoreria?reporte=${reporteName}` +
      `&NOMTAB=${encodeURIComponent(fileName)}` +
      `&NOMID=${encodeURIComponent(nombreid)}` +
      `&NOMID1=${encodeURIComponent(nombreid1)}` +
      `&MONTO=${encodeURIComponent(monto)}` +
      `&CONDI=${encodeURIComponent(condicion)}` +
      `&CONDI2=${encodeURIComponent(condicion2)}` +
      `&TITULO=${encodeURIComponent(titulo)}` +
      `&DIRECCION=${encodeURIComponent(direccion)}` +
      `&DESTINO=${encodeURIComponent(direcciondev)}` +
      `&ENCABEZADO=${encodeURIComponent(enca)}` +
      `&DEVOLV=${encodeURIComponent(estat)}` +
      `&ID=${encodeURIComponent(idAprobacion)}` +
      `&EFISCAL=${encodeURIComponent(idefiscal)}` +
      `&PROVE=${encodeURIComponent(proveedor)}` +
      `&SELECT=${encodeURIComponent(selectDistinct)}`;

    console.log('Generando reporte con URL:', reporteUrl);

    // Abrir el reporte en nueva ventana
    window.open(
      reporteUrl,
      "ImpresionDocumento",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setRecords(props.aprodetalle);
          txtCodigo.current.value = props.aprobaciones.idaprobaciones;
          txtFecha.current.value = moment.utc(props.aprobaciones.fecha).format(
            "YYYY-MM-DD"
          );
          txtObservacion.current.value = props.aprobaciones.observaciones;
          if (props.aprobaciones.aprobado) {
            setVisible(true);
          }
        } else {
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>{'Retención - ' + (parseInt(props.devolver) === 1 ? 'Enviar' : 'Devolver') + ' Solicitud de Traslado de Fondos de Tercero'}</h3>
        <a type="button" onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <AgregarCompromiso
          show={mostrar5}
          operacion={operacion}
          devolver={parseInt(props.devolver)}
          ubica={1}
          tipocom={4}
          tipo={props.tipo}
          retorno={records}
          onDatos={handleAceptarDatos}
          onHideCancela={cerrarModalActualizar}
        />
        <div
          className="col-12 border-azul rounded p-2 m-0 d-flex flex-wrap">
          <div className="col-4 col-lg-2 input-group input-group-sm p-0 m-0">
            <Input label="Código:"
              name="observacion"
              disabled={true}
              id="inputDireccion"
              ref={txtCodigo}
            />
          </div>
          <div className="col-4 col-lg-2 ml-auto p-0 m-0">
            <Input label="Fecha:"
              type="date"
              disabled
              defaultValue={moment.utc(fechaSistema).format("DD/MM/YYYY")}
              id="inputDireccion"
              ref={txtFecha}
            />
          </div>
          <div className="col-12 p-0 m-0 my-2">
            <Textarea label="Observación:"
              style={{ height: 70 }}
              name="observacion"
              onChange={onChange}
              disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
              }
              id="inputDireccion"
              ref={txtObservacion}
            />
          </div>

          <div className="col-12 p-0 m-0 d-flex">
            <div className="col-11 p-0 m-0">
              <TblContainer
                container={{ height: 250, width: "100%", overflow: "auto" }}
              >
                <TblHead />
                <tbody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr
                        key={item + item.idaprobacion}
                        className="table-bordered"
                        disabled={operacion === 1 ? false : true}
                        style={{
                          padding: "0",
                          cursor: "pointer",
                          background:
                            operacion === 1 &&
                              values.idaprobacion === item.idaprobacion
                              ? "lightskyblue"
                              : "white",
                        }}
                        onClick={seleccionarFila(item)}
                      >
                        <td
                          style={{
                            fontSize: "10px",
                            textAlign: "center",
                            width: "50px",
                          }}
                        >
                          {operacion === 1
                            ? item.idaprobacion
                            : item.idordenpago}
                        </td>
                        <td
                          style={{
                            fontSize: "10px",
                            textAlign: "left",
                            width: "350px",
                          }}
                        >
                          {operacion === 1
                            ? item.descripaprobacion
                            : item.concepto}
                        </td>
                        {props.devolver === '0' ?
                          <td 
                            className='align-middle text-uppercase' 
                            style={{ 
                              fontSize: "10px", 
                              textAlign: "center", 
                              width: '350px' 
                            }}>{item.motivo}
                          </td> : ''}
                        <td
                          //ssName="align-baseline"
                          style={{
                            fontSize: "14px",
                            textAlign: "center",
                            width: "60px",
                          }}
                        >
                          <button
                            onClick={opciones(3, item)}
                            disabled={
                              props.operacion === 4 || props.operacion === 2
                                ? true
                                : false
                            }
                            className="btn btn-danger btn-sm rounded-circle"
                          >
                            <i className="fa fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
            </div>
            <div className="col-1 p-0 m-0 align-self-center d-flex flex-column flex-lg-row justify-content-center gap-1">
              <PrimaryButton
                onClick={opciones(1, "")}
                disabled={operacion === 1 ? false : true}
                icon='fa-plus m-0'
              >
              </PrimaryButton>
              {/* <DangerButton
                icon='fa-trash-alt m-0'
                onClick={opciones(3, "")}
                disabled={operacion === 1 ? false : true}
              >
              </DangerButton> */}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        <SuccessButton
          onClick={onChangeValidar}
          disabled={operacion === 1 ? false : true}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
        <InfoButton icon="fas fa-print" disabled={operacion === 1 ? true : false} onClick={handleImprimir}>Imprimir</InfoButton>

      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      {/* <CatalogoSolicitudTraslado
        show={mostrar5}
        onHideCancela={() => {
          setMostrar5(false);
        }}
        onHideAceptaCatalogo={agregarOrdenPago}
      /> */}
    </Modal>
  );
};
